import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "appointment-details d-flex flex-col mha-font-body-sm" }
const _hoisted_2 = { class: "d-flex flex-row" }
const _hoisted_3 = { class: "d-flex flex-col" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "font-color-neutral-dark-grey" }, "Audio & Video", -1)
const _hoisted_5 = { class: "d-flex flex-row align-items-center m-t-4" }
const _hoisted_6 = { class: "d-flex flex-col m-l-32" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "font-color-neutral-dark-grey" }, "Appointment", -1)
const _hoisted_8 = { class: "m-t-16" }
const _hoisted_9 = { class: "d-flex flex-col m-t-24" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "font-color-neutral-dark-grey" }, "Appointment Reason", -1)
const _hoisted_11 = { class: "m-t-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MicrophoneStatusIcon = _resolveComponent("MicrophoneStatusIcon")!
  const _component_VideoStatusIcon = _resolveComponent("VideoStatusIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_MicrophoneStatusIcon, { "microphone-status": _ctx.microphoneStatus }, null, 8, ["microphone-status"]),
          _createVNode(_component_VideoStatusIcon, {
            class: "m-l-24",
            "video-status": _ctx.videoStatus
          }, null, 8, ["video-status"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.appointmentTimeHuman), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.appointment.reason), 1)
    ])
  ]))
}